import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';

import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';

import { Toast } from 'primereact/toast';

import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

import { Tag } from 'primereact/tag';


import BotaoEngrenagem from '../../../Componentes/BotaoEngrenagem';

import TagAtivo from '../../../Componentes/TagAtivo';
import TagInativo from '../../../Componentes/TagInativo';

import DialogDcas from './DialogDcas';


export default function LicencasCollector(props) {
    const toast = React.useRef(null); // Ref para o Toast

    const [licencasCollector, setLicencasCollector] = useState([]);
    const [licenca, setLicenca] = useState({
        visible : false,
        idusuario : -1, 
        idempresa : -1, 
        idcliente : -1,
        chaveDCA : null, 
        razaosocial : null
    })

    const [loading, setLoading] = useState(false);

    const [empresas, setEmpresas] = useState([]);

    const [visible, setVisible] = useState(false);

    const [verInativos, setVerInativos]= useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
        cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
        razaosocial: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
        estado: { value: '', matchMode: FilterMatchMode.EQUALS },
    });

   
    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos === 't' ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);



    const [empresa, setEmpresa]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel

    const overlayBtn = useRef(null); // Referência para o botão de filtro

    useEffect(() => {

        getLicencasCollectorFullData();

    }, []);

    const getData = () => {
        console.log(dataEmpresa)
        clearFilters()

        setLoading(true);

        setTimeout(() => {

            Conexao.post('empresasController/getEmpresas?idempresa=' + dataEmpresa.idrevenda, { filtro: "razaoSocial", tipoFiltro: "" })
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {

                        setEmpresas(response.data.payload);

                        setLoading(false);

                    } else {
                        setEmpresas([])
                        setLoading(false);
                       // showMessageToast('warn', "Não foi possível recuperar dados")
                    }

                }).catch(error => {
                    setEmpresas([])
                    setLoading(false);
                    showMessageToast('error', "erro ao recuperar dados")
                });

        }, 1000);
    };

    const getLicencasCollectorFullData = async () => {
        try {
            if(props.setLoading){
                props.setLoading(true)
            }
            const response = await Conexao.post('dcaController/getLicencasCollectorFullData',{
                idusuario : dataEmpresa.idrevenda, 
                idempresa : dataEmpresa.idempresa, 
                idcliente : dataEmpresa.idcliente
            } );
            if(props.setLoading){
             props.setLoading(false)
            }
            setLicencasCollector(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
        } catch {
            setLicencasCollector([]);
            if(props.setLoading){
                props.setLoading(false)
            }
        }
    };

    

    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
        }));
    };

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
        const foundFields = [];
    
        // Verificando em cada campo se o filtro global está presente
        const fields = ['idempresa', 'cpf_cnpj', 'razaosocial', 'cidade', 'estado'];
        fields.forEach(field => {
            const fieldValue = empresas.map(empresa => empresa[field]?.toString().toLowerCase());
            const matches = fieldValue.some(val => val.includes(value.toLowerCase()));
            if (matches) {
                foundFields.push(field); // Adiciona o campo encontrado
            }
        });
    
        setFieldsFound(foundFields); // Atualiza o estado com os campos encontrados
    };
    
    
    
    const renderBotaoEditar = (row, opcao) => {
  
        return (
            <Button 
                icon="pi pi-pencil"
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}
                tooltip="Editar dados da empresa" tooltipOptions={{ position: 'left' }}
            />
        );
    };

    const renderBotaoDataclassic= (row, opcao) => {
  
        return (
            <BotaoEngrenagem                 
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}              
                tooltip="Alterar configurações da integração com o Dataclassic" tooltipOptions={{ position: 'left' }}
            />
        );
    };
    const renderStatusRow= (row, opcao) => {

        return (
            row.ativo =='t' ? <Tag severity="success" value="ATIVO" style={{cursor :'pointer'}} onClick={()=>{

            }}></Tag> : <Tag severity="danger" value="INATIVO" style={{cursor :'pointer'}}></Tag>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-primary p-button-sm" 
                        onClick={getLicencasCollectorFullData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />            
                </div>
                
            </div>
        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
            cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
            razaosocial: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
            estado: { value: '', matchMode: FilterMatchMode.EQUALS },
        });
        setFieldsFound([]); // Resetando os campos encontrados
    };



    useEffect(()=>{

    }, [fieldsFound])
    

    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}
                            value={licencasCollector}
                            paginator                 
                            rows={15} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem', fontSize : '10px' }}                   
                            bodyStyle={{fontSize : '10px'}}
                            filters={filters} // **Adicione esta linha**
                            globalFilterFields={['idempresa', 'idcliente', 'razaosocial', 'chave', 'monitorartoner', 'equipamentos']}                            
                        >
                            <Column 
                                bodyStyle={{ fontSize: '11px' , width : '20%' , paddingTop:'8px', paddingBottom: '8px'}} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px' }} 
                                field="chave" 
                                header="Chave" 
                                name="chave" 
                                body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable
                                filter 
                                filterElement={(options) => (
                                    <InputText
                                        value={options.value}
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder="Digite a Chave"
                                        />
                                )} />

                            <Column 
                                bodyStyle={{ fontSize: '11px' , width : '30%' , paddingTop:'8px', paddingBottom: '8px'}} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px' }} 
                                field="razaosocial" 
                                header="Cliente" 
                                name="razaosocial" 
                                body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterElement={(options) => (
                                    <InputText
                                        value={options.value}
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder="Digite a razão social"
                                        />
                                )}/>
                            <Column 
                                bodyStyle={{ fontSize: '11px' , width : '10%', paddingTop:'8px', paddingBottom: '8px' }} 
                                headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px'}} 
                                field="datacriacao" 
                                header="Criação" 
                                name="datacriacao" 
                                body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable />
        
                            <Column 
                                bodyStyle={{ fontSize: '11px' , width : '20%', paddingTop:'8px', paddingBottom: '8px' }} 
                                headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px'}} 
                                field="equipamentos" 
                                header="Equipamentos" 
                                name="equipamentos" 
                                sortable
                                body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                    />
        

                            <Column 
                                header="DCAs"
                                bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                <Button   
                                    icon="pi pi-cog" 
                                    className= "p-button-secondary p-button-sm" 
                                    onClick={()=>{
                                        setLicenca({
                                                visible : true,
                                                idusuario : row.idusuario, 
                                                idempresa : row.idempresa, 
                                                idcliente : row.idcliente,
                                                chaveDCA : row.chave, 
                                                razaosocial : row.razaosocial
                                        })
                                    }}/>
                               
                                }                         
                            />
                            <Column 
                                bodyStyle={{ fontSize: '11px' , width : '10%', paddingTop:'8px', paddingBottom: '8px' }} 
                                headerStyle={{ fontSize:'12px' , paddingTop:'8px', paddingBottom: '8px',}} 
                                header="Monitoramento" 
                                className='text-center'
                                field='monitorartoner'
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                row.monitorartoner === 't' ? <TagAtivo tooltip ='Esta licença de coleta esta ATIVA'
                                    tooltipOptions={{ position: 'left' }}/>
                                
                                :  
                                <TagInativo tooltip ='Esta licença de coleta esta INATIVA'
                                    tooltipOptions={{ position: 'left' }}/>
                                }
                                    />
                                                                
                            <Column 
                                header="Status"
                                bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                row.ativo === 't' ? <TagAtivo/>                                
                                :  
                                <TagInativo/>
                                }                         
                            />
        
        
                        </DataTable>
                    
                </div>

                {/* OverlayPanel com campos de filtro */}
                <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>
                        <div className="p-field">
                            <label htmlFor="idempresa">Código</label>
                            <InputText
                                id="idempresa"
                                value={filters.idempresa.value}
                                onChange={(e) => handleFilterChange(e, 'idempresa')}
                            />
                        </div>
                        
                        <div className="p-field">
                            <label htmlFor="razaosocial">Razão Social</label>
                            <InputText
                                id="razaosocial"
                                value={filters.razaosocial.value}
                                onChange={(e) => handleFilterChange(e, 'razaosocial')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="cidade">Cidade</label>
                            <InputText
                                id="cidade"
                                value={filters.cidade.value}
                                onChange={(e) => handleFilterChange(e, 'cidade')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="estado">UF</label>
                            <InputText
                                id="estado"
                                value={filters.estado.value}
                                onChange={(e) => handleFilterChange(e, 'estado')}
                            />
                        </div>
                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
            </div>
           
           

            <Toast ref={toast} />
            <DialogDcas licenca ={licenca} 
                dataEmpresa ={dataEmpresa}
                idcliente={licenca.idcliente}
                setLoading ={()=>{

                }}
                showMessage ={showMessageToast}
                Conexao ={Conexao}
                setLicenca ={()=>{
                    setLicenca({
                            visible : false,
                            idusuario : -1, 
                            idempresa : -1, 
                            idcliente : -1, 
                            chaveDCA : null, 
                            razaosocial : null
                    })
                }}/>
        </Layout>
    );
}
